import {
  getDefaultPrivacyStatus as publicGetDefaultPrivacyStatus,
  setDefaultPrivacyStatus as publicSetDefaultPrivacyStatus,
} from './members-v1-default-privacy-default-privacy.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getDefaultPrivacyStatus: MaybeContext<
  BuildRESTFunction<typeof publicGetDefaultPrivacyStatus> &
    typeof publicGetDefaultPrivacyStatus
> = /*#__PURE__*/ createRESTModule(publicGetDefaultPrivacyStatus);
export const setDefaultPrivacyStatus: MaybeContext<
  BuildRESTFunction<typeof publicSetDefaultPrivacyStatus> &
    typeof publicSetDefaultPrivacyStatus
> = /*#__PURE__*/ createRESTModule(publicSetDefaultPrivacyStatus);

export { Privacy } from './members-v1-default-privacy-default-privacy.universal.js';
export {
  DefaultPrivacy,
  GetDefaultPrivacyStatusRequest,
  GetDefaultPrivacyStatusResponse,
  SetDefaultPrivacyStatusRequest,
  SetDefaultPrivacyStatusResponse,
} from './members-v1-default-privacy-default-privacy.universal.js';
export { PrivacyWithLiterals } from './members-v1-default-privacy-default-privacy.universal.js';
